import Vue from 'vue'
import VueYandexMetrika from 'vue-yandex-metrika';
import VueGtag from 'vue-gtag';

import { installSafeDiagnostics } from './utils/legacy-safety';
import App from './App.vue'
import router from './router'
import store from './store'
import 'bootstrap';

Vue.config.productionTip = false;

import '../public/css/app.css';
import 'slick-carousel/slick/slick.css';

const isProduction = process.env.NODE_ENV === 'production';

if (isProduction) {
  // Preserve suppression of old debug logs containing application objects.
  window.console.log = () => {};
  window.console.info = () => {};
  window.console.debug = () => {};
  installSafeDiagnostics(Vue, window, {
    error: window.console.error.bind(window.console),
    warn: window.console.warn.bind(window.console),
  });
}

import './utils/scroll-stop';
import './utils/click-outside';
import './utils/popper';
import './utils/vue-mq';
import './utils/scrollbar';
import './utils/slick';
import './utils/back-to-top';

// v-focus directive for components
Vue.directive('focus', {
  inserted: function (el) {
    el.focus()
  }
});

if (process.env.VUE_APP_YANDEX_METRIKA) {
  Vue.use(VueYandexMetrika, {
    id: process.env.VUE_APP_YANDEX_METRIKA,
    router: router,
    env: process.env.NODE_ENV
  })
}

if (process.env.VUE_APP_GOOGLE_ANALYTICS) {
  Vue.use(VueGtag, {
    config: { id: process.env.VUE_APP_GOOGLE_ANALYTICS }
  });
}

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
